export const USER_BY_ID = (id) => `/v2/users/${id}`;
export const USERS = `/v2/users`;
export const ROLE_BY_ID = (id) => `/v2/user-roles/${id}`;
export const PASSWORD = (id) => `/v2/change-password-user/${id}`;
